import React from 'react';
import {Navigate, Route} from 'react-router-dom';

import {FolderType} from '#/FolderTree/Folder';
import {ConditionalRouteWrapper} from '_/utilities/ConditionalRouteWrapper';
import {GlobalPermissions} from '_/utilities/types';

const CasusModule = React.lazy(() => import('../modules/casus'));
const CasusList = React.lazy(() => import('../modules/casus/CasusListRoute'));
const SubrouteLayout = React.lazy(() => import('../modules/casus/Routes'));

const LogViewModule = React.lazy(
  () => import('../modules/log-view/LogViewModule')
);
const TaskModule = React.lazy(
  () => import('../modules/tasks/exports/CasusTaskModule')
);
const DocumentsModule = React.lazy(
  () => import('../modules/documents/DocumentsModule')
);
const DeletedDocumentsModule = React.lazy(
  () => import('../modules/documents/DeletedDocumentsModule')
);

const CommunicationModule = React.lazy(
  () => import('../modules/communication/Submodule')
);
const ContactsModule = React.lazy(
  () => import('../modules/casus/screens/contacts')
);
const OverviewModule = React.lazy(
  () => import('../modules/casus/screens/overview')
);
const SettingsModule = React.lazy(
  () => import('../modules/casus/screens/settings')
);
const ArchiveModule = React.lazy(
  () => import('../modules/casus/screens/archives')
);
const NotesModule = React.lazy(() => import('../modules/notes/NotesModule'));

const OpenFeesModule = React.lazy(() =>
  import('../modules/invoicing/CasusInvoicingModules').then(
    ({CasusOpenFeesModule}) => ({default: CasusOpenFeesModule})
  )
);
const InvoiceContainersModule = React.lazy(() =>
  import('../modules/invoicing/CasusInvoicingModules').then(
    ({CasusInvoiceContainersModule}) => ({
      default: CasusInvoiceContainersModule,
    })
  )
);
const InvoicesModule = React.lazy(() =>
  import('../modules/invoicing/CasusInvoicingModules').then(
    ({CasusInvoicesModule}) => ({
      default: CasusInvoicesModule,
    })
  )
);

const PaymentsModule = React.lazy(() =>
  import('../modules/invoicing/CasusInvoicingModules').then(
    ({CasusPaymentsModule}) => ({
      default: CasusPaymentsModule,
    })
  )
);
const ClientMoneyModule = React.lazy(() =>
  import('../modules/invoicing/screens').then(({ClientMoney}) => ({
    default: ClientMoney,
  }))
);

export const CasusSubRoutes = (
  <Route element={<CasusModule />}>
    <Route element={<CasusList />} index />
    <Route element={<SubrouteLayout />} path=':activeCasusId/'>
      <Route element={<OverviewModule />} path='overview/' />
      <Route element={<SettingsModule />} path='settings/' />
      <Route element={<ArchiveModule />} path='archives/' />
      <Route
        element={
          <ConditionalRouteWrapper
            featureName='notes'
            module={<NotesModule />}
          />
        }
        path='notes/'
      />
      <Route element={<OpenFeesModule />} path='fees/*' />
      <Route
        element={<InvoiceContainersModule />}
        path='invoice-containers/*'
      />
      <Route element={<InvoicesModule />} path='invoices/*' />
      <Route
        element={
          <ConditionalRouteWrapper
            module={<PaymentsModule />}
            requiredPermission={GlobalPermissions.Invoicing.ManagePayments}
          />
        }
        path='payments/*'
      />
      <Route
        element={
          <ConditionalRouteWrapper
            featureName='clientMoney'
            module={<ClientMoneyModule />}
            requiredPermission={GlobalPermissions.Invoicing.ManageClientMoney}
          />
        }
        path='client-money/*'
      />
      <Route element={<ContactsModule />} path='contacts/' />
      <Route
        element={<Navigate to={`${FolderType.AllItems}/`} replace />}
        path='log-view/'
      />
      <Route element={<LogViewModule />} path='log-view/:activeFolderId/' />
      {/* Communication routes*/}
      <Route
        element={<Navigate to={`${FolderType.AllItems}/`} replace />}
        path='communication/'
      />
      <Route
        element={<CommunicationModule />}
        path='communication/:activeFolderId/'
      />
      {/* Task-management routes */}
      <Route element={<TaskModule />} path='tasks-management/' />
      {/* Document routes */}
      <Route
        element={<Navigate to={`${FolderType.AllItems}/`} replace />}
        path='documents/'
      />
      <Route
        element={<DeletedDocumentsModule />}
        path={`documents/${FolderType.Trash}/`}
      />
      <Route element={<DocumentsModule />} path='documents/:activeFolderId/' />
      <Route
        element={<DocumentsModule />}
        path='documents/submissions/:activeSubmissionId/'
      />
    </Route>
  </Route>
);
